export default __webpack_public_path__ + "static/media/api-integrations.33f37cf5.svg";